export default "__VITE_ASSET__e3992f9e__"